import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextarea,{attrs:{"label":_vm.label,"maxlength":_vm.maxLength},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VIcon,_vm._g({staticStyle:{"cursor":"default"}},on),[_vm._v("help")])]}}])},[_c('span',{staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.getClarificationText(_vm.textfieldKey)))])])]},proxy:true}]),model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }